module.exports = __webpack_public_path__ + "static/media/1920px-Netflix_2015_logo.svg.eec374d7.png";